export const pxToRem = (pxValue: number) => `${pxValue / 16}rem`;
